module.exports = __webpack_public_path__ + "media/images/emblems/Daellikon-blazon-b0f063f654fe9a6f491f0bafc6ad5202.svg";